export const HOME_PAGE_USER_RESTRICTION_SEEN = "HOME_PAGE_USER_RESTRICTION_SEEN";

export const DS_HELPLINE_NUMBER = "9240263601";
